import { Directive, Injector, OnDestroy, OnInit } from '@angular/core';
import { GlobalEventsService, TiersService } from '../services';
import { Tier } from '../models';
import { Router } from '@angular/router';
import { pairwise, Subscription } from 'rxjs';

@Directive()
export abstract class TierAware implements OnInit, OnDestroy {
  globalEventsService: GlobalEventsService;
  router: Router;
  tierService: TiersService;

  tierSubscription?: Subscription;

  constructor(injector: Injector) {
    this.globalEventsService = injector.get(GlobalEventsService);
    this.router = injector.get(Router);
    this.tierService = injector.get(TiersService);
  }

  ngOnInit() {
    this.globalEventsService.showTierSelector();

    const tier = this.globalEventsService.getSelectedTier();
    if (tier) this.afterTierChange(tier);

    this.subscribeToTierChange();
  }

  ngOnDestroy() {
    this.tierSubscription?.unsubscribe();
    this.globalEventsService.hideTierSelector();
  }

  subscribeToTierChange() {
    this.tierSubscription = this.globalEventsService.selectedTier$
      .pipe(pairwise())
      .subscribe(([prev, curr]) => {
        if (!(prev == null && curr == null))
          if (curr === null) {
            this.router.navigate(['/', 'tier']);
          } else {
            this.tierService.handleDocumentTypesForInput(curr);
            this.afterTierChange(curr);
          }
      });
  }

  /**
   * Hook method that is called after the tier has changed.
   * Can be overritten by subclasses to provide custom behavior.
   */
  afterTierChange(tier: Tier) {}
}
